import { mogamboRequestV2 } from '@src/api/utils';
import { BASE_URL } from '@src/const';

export const createNewAissNode = (data) => {
  const url = `${BASE_URL}node/aiss_intent/data/`;
  const headers = {
    'x-haptik-bot-name': data.domain_name,
  };
  const response = mogamboRequestV2(url, 'POST', data, false, headers);
  return Promise.resolve(response);
};

export const updateAissNode = (data) => {
  const url = `${BASE_URL}node/aiss_intent/data/${data.id}/`;
  const response = mogamboRequestV2(url, 'POST', data);
  return Promise.resolve(response);
};

export const fetchAissNodeData = (data) => {
  const url = `${BASE_URL}node/aiss_intent/data/${data.id}/`;
  const response = mogamboRequestV2(url, 'GET');
  return Promise.resolve(response);
};
